/* Component Dependencies */
var guestInformationTemplate = require('templates/guestInformation.hbs');
var guestInformationFormTemplate = require('templates/guestInformationForm.hbs');
var contactInformationFormTemplate = require('templates/contactInformationForm.hbs');
var AriesComponent = require('libs/aries-component');
var ResponsiveUtils = require('utils/responsiveUtils');
var $ = require('jquery');
var Popup = require('libs/popup');

AriesComponent.create({
  type: 'guestInformation',

  template: {
    'guestInformation': guestInformationTemplate,
    'guestInformationForm': guestInformationFormTemplate,
    'contactInformationForm': contactInformationFormTemplate
  },

  subscribe: {
    'TOGGLE_VISIBLE_REW_LVL': 'toggleVisibleRewardsLevel',
    'PREVENT_CLEAR_AFTER_SUBMIT': 'clearUserInfo'
  },

  bindEvents: function () {
    var _self = this;

    window.$(_self.$el.find('input')[0].form).on('reset', _self.onFormRest.bind(_self));
    
    // [PTRN-1469] selectric ADA fix
    window.$(document).on('selectric-init', function(evt, src, selectric) {
      selectric.elements.label.attr('aria-label', $('[for="' + src.id + '"]').text());
    });

    _self.responsiveUtils = ResponsiveUtils.create();
    _self.responsiveUtils.init();

    var signInModel = new Popup({
      url: '/signInOverlay.mi',
      selector: '[href^="/sign-in.mi"]',
      sourceBlock: '.modal-content',
        afterClose: function() {
          if(window.gigya) {
          window.gigya.__initialized = false;
        }
      }
    });

    signInModel.register();
  },

  onFormRest: function() {
    this.$el.find('input').each(function(index, input) {
      $(input).attr('value', '');
      input.value = "";
      input.readOnly = false;
    });
  },

  toggleVisibleRewardsLevel: function(data) {
    var visible = data.visible;
    var userState = this.$el.data('userState');
    var triggeredEvent = window.event;

    visible ? this.$el.removeClass('is-hidden') : this.$el.addClass('is-hidden');
    if (visible) {
      if (userState != 'Authenticated') {
        if (triggeredEvent != undefined && triggeredEvent.type != 'readystatechange') {
          this.onFormRest();
        }
      }
      window.$(document).trigger('GLOBAL_ELEMENTS_REINIT.mi-foundation');
    }
  },

  clearUserInfo: function(refreshFlagValue){
    var userState = this.$el.data('userState');
    if (!refreshFlagValue) {
      if (userState != 'Authenticated') {
        this.onFormRest();
      }
    }
  }
});
